import { ORDERS_PAGE as dict } from '@/resources/dict'

export const isRatingLow = (orderRating: number | null = 0) => {
  const MINIMUM_REQUIRED_RATING = 5

  if (orderRating !== null && orderRating < MINIMUM_REQUIRED_RATING) {
    return true
  }

  return false
}

export const getRatingTime = (ratingTime: number = 0) => {
  /* time in seconds */
  const minute = 60
  const ratingTimeInMinutes = Number.parseInt(String(ratingTime / minute), 10)

  const hour = minute * 60
  const ratingTimeInHours = Number.parseInt(String(ratingTime / hour), 10)

  const day = hour * 24
  const ratingTimeInDays = Number.parseInt(String(ratingTime / day), 10)

  switch (true) {
    case ratingTimeInMinutes <= 0:
      return dict.ratingTime.lessThanOneMinute

    case ratingTime <= hour:
      return `${dict.ratingTime.ago} ${ratingTimeInMinutes} ${
        ratingTimeInMinutes <= 1
          ? dict.ratingTime.minute
          : dict.ratingTime.minutes
      }`

    case ratingTime > hour && ratingTime <= day:
      return `${dict.ratingTime.ago} ${ratingTimeInHours} ${
        ratingTimeInHours <= 1 ? dict.ratingTime.hour : dict.ratingTime.hours
      }`

    case ratingTime > day:
      return `${dict.ratingTime.ago} ${ratingTimeInDays} ${
        ratingTimeInDays <= 1 ? dict.ratingTime.day : dict.ratingTime.days
      }`

    default:
      return ''
  }
}
